export const ru = {
    'clear-end-date-confirm-text':
        'Дата окончания будет сброшена. Показы будут идти до окончания денежных средств на кампании.'
};
